import React from 'react';
import './WatercolorLoader.css';

const SIZES = {
  small: 28,
  default: 48,
  large: 72,
};

/**
 * Watercolor splotch loader — five muted dots appear clockwise in a ring.
 */
export default function WatercolorLoader({
  size = 'default',
  label = 'Loading',
  className = '',
}) {
  const px = typeof size === 'number' ? size : SIZES[size] || SIZES.default;
  return (
    <div
      className={['watercolor-loader', className].filter(Boolean).join(' ')}
      role="status"
      aria-live="polite"
      aria-label={label}
      style={{ width: px, height: px }}
    >
      <span className="watercolor-loader__splotch watercolor-loader__splotch--1" />
      <span className="watercolor-loader__splotch watercolor-loader__splotch--2" />
      <span className="watercolor-loader__splotch watercolor-loader__splotch--3" />
      <span className="watercolor-loader__splotch watercolor-loader__splotch--4" />
      <span className="watercolor-loader__splotch watercolor-loader__splotch--5" />
      <span className="watercolor-loader__sr">{label}</span>
    </div>
  );
}
